import React, { useEffect, useState, } from 'react'
import { Link, } from 'react-router-dom'

import $ from 'jquery';
import axios from 'axios'
import Swal from 'sweetalert2';

import useAuth from '../../controllers/users/useAuth'

import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, awaitDelay, processEvaluateGet, languageObjGet,
    isUndNullEmp, LoadingSection
} from '../../helpers/settings'
import { buildingDocumentModelGet } from '../../models/buildings/buildingDocument';
import BuildingDocumentAddDetailEdit from './BuildingDocumentAddDetailEdit';

import Menu from '../main/Menu'
import BuildingHeader from './BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'BuildingDocuments';

const { app, icons, labels, messages, } = globalSettings;
const { backend, } = app;

export default function BuildingDocuments({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    let swalProperties = {};
    const auth = useAuth();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [showLoading, setShowLoading] = useState({ buildings: true, documents: true, });
    //const [showData, setShowData] = useState(false);
    const [processValues, setProcessValues] = useState({
        auth: auth,
        documentShowModal: false,
        type: 0,
        dtId: '',
        dtRowIndex: 0,
    });

    //#region buildings
    const buildingsId = 'buildings';
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion buildings

    //#region documents
    let documents = [];
    const dtDocumentsId = 'dtDocuments';
    const [document, setDocument] = useState(buildingDocumentModelGet({}));
    const [btnDocumentAddDisabled, setBtnDocumentAddDisabled] = useState(true);
    const [btnDocumentsSyncDisabled, setBtnDocumentsSyncDisabled] = useState(true);
    //#endregion documents

    //#region others
    const controls = {
        buttons: {
            // create: {
            //     className: 'btn btn-outline-success float-right btn-sm',
            //     id: 'btnCreate',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            documents: {
                buttons: {
                    create: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btnDtdocumentsCreate',
                    },
                },
                icons: {
                    create: {
                        id: 'iconDtdocumentsCreate',
                        className: icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtDocumentsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtDocumentsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    create: {
                        id: 'spDtdocumentsCreate',
                        className: '',
                    }
                },
            },
        },
        icons: {
            // create: {
            //     id: 'iconCreate',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // email: {
            //     id: 'inputEmail',
            // },
            // password: {
            //     id: 'inputPassword',
            // },
        },
        spinners: {
            // create: {
            //     id: 'spCreate',
            //     className: '',
            // }
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others
    //#endregion variables

    //#region documents (methods)
    const documentsGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'documentsGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ buildings: false, documents: true, });
            //setShowData(false);

            $(`#${dtDocumentsId}`)?.DataTable()?.rows()?.clear()?.draw(true);

            //#region variables
            let isEditLocal = false;
            let isDeleteLocal = false;
            let buildingLocal = buildingModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setBtnDocumentAddDisabled(true);
            setBtnDocumentsSyncDisabled(true);

            documents = [];
            setBuilding({});
            //#endregion initialize

            //#region data get
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id }) => id === buildingIdLocal);
                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        conditionals: [
                            { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingLocal?.id}` }
                        ],
                        ordersBy: [],
                        buildingId: buildingIdLocal,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, documents: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    let documentsLocal = response?.result || [buildingDocumentModelGet({})];

                    if (!isUndNullEmp({ data: documentsLocal, subMethod: currentMethod, })?.result && documentsLocal?.length > 0) {
                        documentsLocal?.map((detail) => (
                            documents.push([
                                detail?.title,
                                detail?.description,
                                detail?.files?.length || 0,
                                buttonProcessGet({
                                    id: detail?.id,
                                    description: detail?.title,
                                    showDetails: true,
                                    labelDetails: labels?.detail?.[languageObj?.id],
                                    enabledDetails: true,
                                    showEdit: true,
                                    labelEdit: labels?.edit?.[languageObj?.id],
                                    enabledEdit: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showDelete: true,
                                    labelDelete: labels?.delete?.[languageObj?.id],
                                    enabledDelete: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.delete?.en.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    processButtons: [],
                                    subMethod: currentMethod,
                                })?.result,
                            ])
                        ));

                        //#region check if an add register
                        isEditLocal = processEvaluateGet({
                            object: documentsLocal?.[0],
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        isDeleteLocal = processEvaluateGet({
                            object: documentsLocal?.[0],
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        //#endregion check if an add register
                    } else {
                        //#region check if an add register
                        isEditLocal = processEvaluateGet({
                            object: buildingLocal,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;

                        isDeleteLocal = isEditLocal;
                        //#endregion check if an add register
                    }
                }

                setBuilding(buildingLocal);
                setBtnDocumentsSyncDisabled(false);
                setBtnDocumentAddDisabled(!(isEditLocal && isDeleteLocal));
            }
            //#endregion data get

            //#region dataTables set / datatables load data
            // response = dataTablesSet();
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({buildings: false, documents: false,});
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            $(`#${dtDocumentsId}`)?.DataTable()?.rows?.add(documents)?.draw(true);
            //#endregion dataTables set / datatables load data

            setShowLoading({ buildings: false, documents: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, documents: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const documentsDataTablesSet = ({ subMethod = '', }) => {
        const currentMethod = 'documentsDataTablesSet';
        let response = responseGet();
        try {
            $(`#${dtDocumentsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.title?.[languageObj?.id], width: '30%', },
                    { title: labels?.remark?.[languageObj?.id], width: '55%', },
                    { title: labels?.files?.[languageObj?.id], className: 'text-right', width: '10', orderable: false, searchable: false, },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtDocumentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const documentAddEditDetailsGetAsync = async ({ e = {}, processType_ = 0, id = '', description = '', dtRowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'documentAddEditDetailsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            let documentLocal = buildingDocumentModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion initialize

            //#region check data
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion check data

            if (processType_ === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else if (processType_ > 0) {
                setShowLoading({ buildings: false, documents: true, });
            }

            //#region get document (building)
            switch (processType_) {
                case 0:
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond });

                    documentLocal = buildingDocumentModelGet({
                        buildingId: buildingIdLocal,
                        userId: auth?.user?.uid,
                    });
                    break;
                //#region old code
                // case 1:
                //     response = await documetByIdGetAsync(id);

                //     if (!response?.isSuccess || response?.isWarning) {
                //         controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                //         await sendMessageCloseCurrentWindowAsync({
                //             msgType: response?.msgType,
                //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                //             closeWindow: false,
                //             urlGoTo: response?.urlGoTo,
                //             auth: auth,
                //             isLogout: false,
                //             languageId: languageObj?.id,
                //             subMethod: currentMethod,
                //         });
                //         return;
                //     }

                //     documentLocal = response.result;
                //     break;
                //#endregion old code
                //#region old code
                // case 2:
                //     response = await documetByIdGetAsync(id);

                //     if (!response?.isSuccess || response?.isWarning) {
                //         controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                //         await sendMessageCloseCurrentWindowAsync({
                //             msgType: response?.msgType,
                //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                //             closeWindow: false,
                //             urlGoTo: response?.urlGoTo,
                //             auth: auth,
                //             isLogout: false,
                //             languageId: languageObj?.id,
                //             subMethod: currentMethod,
                //         });
                //         return;
                //     }

                //     documentLocal = response.result;
                //     break;
                //#endregion old code
                default:
                    response = await documetByIdGetAsync({ id: id, subMethod: currentMethod, });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, documents: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    documentLocal = response.result;
                    break;
            }

            setDocument(documentLocal);
            //#endregion get document (building)

            setProcessValues({
                auth: auth,
                documentShowModal: true,
                type: processType_,
                dtId: dtDocumentsId,
                dtRowIndex: dtRowIndex,
            });

            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType_ > 0) {
                setShowLoading({ buildings: false, documents: false, });
            }
        } catch (ex) {
            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType_ > 0) {
                setShowLoading({ buildings: false, documents: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    //#region old code
    // const documentDeleteAsync = async (e = {}, documentId = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         //#region show message

    //         e.preventDefault();

    //         swalProperties = {
    //             icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: `${labels?.document?.[languageObj?.id]}: <b>${description}</b><br/>${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
    //             timer: null,
    //             confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: globalSettings?.colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         //#endregion show message

    //         //#region delete data

    //         if (isConfirmed) {
    //             sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //             headerObj = {
    //                 headers: {
    //                     authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //                 },
    //             };

    //             //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/${documentId}`, headerObj);
    //             result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/${documentId}`, headerObj);
    //             response = result.data;

    //             if (!response?.isSuccess || response?.isWarning) {
    //                 await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //                 return;
    //             }

    //             //#region building documents (datatable)

    //             $(`#${dtDocumentsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

    //             //#endregion building documents (datatable)

    //             response.msgType = 0;
    //             response.msgText = `${messages?.documentDeletedSuccessFully?.[languageObj?.id]}<br/>`;
    //             response.msgText += `${labels?.document?.[languageObj?.id]}: <b>${description}</b>`;

    //             sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //         }
    //         //#endregion delete data
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: documentDeleteAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    //     return response;
    // }
    //#endregion old code

    const documentDeleteAsync = async ({ id_ = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'documentDeleteAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${labels?.document?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });

                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/${id_}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        //#region building documents (datatable)
                        $(`#${dtDocumentsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion building documents (datatable)

                        //#region finalMsg
                        response.msgType = 0;
                        response.msgText = `${messages?.documentDeletedSuccessFully?.[languageObj?.id]}<br/>`;
                        response.msgText += `${labels?.document?.[languageObj?.id]}: <b>${description}</b>`;

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        //#endregion finalMsg
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const documetByIdGetAsync = async ({ id = '', subMethod = '', }) => {
        const currentMethod = 'documetByIdGetAsync';
        let response = responseGet();
        try {
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion documents (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ buildings: true, documents: true, });
            //setShowData(false);

            //#region initialize
            documents = [];
            setBtnDocumentAddDisabled(true);
            //#endregion initialize

            //#region dataTables et / query code
            response = dataTablesSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, documents: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTables et / query code

            //#region data get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlHome,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, documents: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion data get

            setShowLoading({ buildings: false, documents: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading(false);
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtDocumentsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtDocumentsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            documentAddEditDetailsGetAsync({ e: e, processType_: 1, id: id, description: description, dtRowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case 'details':
                            documentAddEditDetailsGetAsync({ e: e, processType_: 2, id: id, description: description, dtRowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            documentDeleteAsync({ e: e, id_: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataTablesSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            //#region set dataTable
            response = documentsDataTablesSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion set dataTable

            //#region queryCode set
            response = queryCodeSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion queryCode set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.documents?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.documents?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.documents?.spinners?.create?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.documents?.icons?.create?.id}`)?.addClass(controls?.dataTables?.documents?.icons?.create.className);
                    $(`#${controls?.dataTables?.documents?.buttons?.create?.id}`)?.addClass(controls?.dataTables?.documents?.buttons?.create?.className);
                    $(`#${controls?.dataTables?.documents?.spinners?.create?.id}`)?.addClass(controls?.dataTables?.documents?.spinners?.create.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.documents?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.documents?.spinners?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.documents?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.documents?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.documents?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: '', });
    }, [auth]); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='process' process='buildingDocuments' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.document?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.document?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnDocumentsSyncDisabled}
                            methodGetAsync={documentsGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.buildings}
                            languageObj={languageObj} />

                        {/*apartments*/}
                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.documents}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.document?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.documentLogo}></img> - {labels?.document?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                {/* {!showLoading ?
                                                    <div> */}
                                                {/* {showData ?
                                                            <div> */}
                                                <button id={controls?.dataTables?.documents?.buttons?.create?.id}
                                                    className={controls?.dataTables?.documents?.buttons?.create?.className}
                                                    tooltip='tooltip'
                                                    title={labels?.create?.[languageObj?.id]}
                                                    disabled={btnDocumentAddDisabled}
                                                    onClick={(e) => documentAddEditDetailsGetAsync({ e: e, processType_: 0, id: '', description: '', dtRowIndex: 0, subMethod: 'btn - documentAdd', })}>
                                                    <i id={controls?.dataTables?.documents?.icons?.create?.id} className={controls?.dataTables?.documents?.icons?.create?.className} /> <span id={controls?.dataTables?.documents?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtDocumentsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div>
                                                            :
                                                            <div></div>
                                                        } */}
                                                {/* </div>
                                                    :
                                                    <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                        width={40}
                                                        height={40}
                                                        color={globalSettings?.colors?.infoColorExp}
                                                        msgText={messages?.processing?.[languageObj?.id]}
                                                        msgOrientation='text-center'
                                                        msgTextMuted={true} />
                                                } */}
                                            </div>
                                        </div>

                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'>
                                    </div> */}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>

            {!isUndNullEmp({ data: document, subMethod: currentMethod, })?.result && processValues?.documentShowModal ?
                <BuildingDocumentAddDetailEdit $={$}
                    document={document}
                    setDocument={setDocument}
                    processValues={processValues}
                    setProcessValues={setProcessValues}
                    languageObj={languageObj} />
                :
                <div></div>
            }
        </div>
    )
}